import axios from 'axios';
import { defaultAgent, apiResponse } from "../helpers/web-agent";
import { tokenExpired } from './auth';
import { toastError } from './toast';
import {
    CHAT_CONTACT_LIST, CONNECT_XMPP, CONNECTED_XMPP, DISCONNECT_XMPP,
    SEND_MESSAGE_TO_XMPP, RECEIVED_MESSAGE_FROM_XMPP, START_CONVERSATION,
    PUSH_MESSAGE, PUSH_BULK_MESSAGE, FILE_UPLOADED_ON_SUCCESS,
    FILE_UPLOAD_ON_FAILTURE, FILE_UPLOADING, CHAT_PRESENT, CHAT_EG_LIST, GET_USER_LIST,
    GET_UNREAD_MESSAGE_COUNT
} from "../constants/action-types";
import { FILE_STORAGE_GOOGLE } from '../constants';
import config from '../constants/config';
import { ADDED_FAVORITE } from '../constants/messages';
import { setChatAppId } from '../helpers/session';

export const connectXMPP = (loginId, farmId) => ({ type: CONNECT_XMPP, loginId, farmId });

export const connectedXMPP = () => ({ type: CONNECTED_XMPP });

export const disconnectXMPP = () => ({ type: DISCONNECT_XMPP });

export const sendMessageToXMPP = message => ({ type: SEND_MESSAGE_TO_XMPP, message });

export const pushMessage = message => ({ type: PUSH_MESSAGE, message });

export const pushBulkMessages = messages => ({ type: PUSH_BULK_MESSAGE, messages });

export const receivedMessageFromXMPP = message => ({ type: RECEIVED_MESSAGE_FROM_XMPP, message });

export const chatPresent = isPresent => ({ type: CHAT_PRESENT, isPresent });

export const startConversation = to => ({ type: START_CONVERSATION, to });

export const chatContactList = (contactList, userList) => ({ type: CHAT_CONTACT_LIST, contactList: contactList || [], userList: userList || [] });

export const userList = data => ({ type: GET_USER_LIST, payload: data });

export const setUnreadMessageCount = (data, clearMessageCountTimer) => ({ type: GET_UNREAD_MESSAGE_COUNT, payload: data, isClearInterval: clearMessageCountTimer });

export const updateChatEGList = (farmId, egList) => ({ type: CHAT_EG_LIST, farmId, egList: egList || [] });

export const fileUploadedOnSuccess = (to, messageId, attachmentId, url, duration) =>
    ({ type: FILE_UPLOADED_ON_SUCCESS, to, messageId, attachmentId, url, duration });

export const fileUploadOnFailure = (to, messageId, attachmentId) =>
    ({ type: FILE_UPLOAD_ON_FAILTURE, to, messageId, attachmentId });

export const fileUploadInProgress = (to, messageId, attachmentId, uploadPercent, size) =>
    ({ type: FILE_UPLOADING, to, messageId, attachmentId, uploadPercent, size });

export const getChatCredentials = () => dispatch => {
    defaultAgent.get('api/chat/provider/credentials?encryption=true').then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            setChatAppId(agentResult.data);
        }
    }).catch(ex => {
        console.log(ex);
    });
}

export const getUnreadMessageCount = (clearMessageCountTimer = false) => dispatch => {
    defaultAgent.get('api/chat/provider/message/unreadcount').then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(setUnreadMessageCount(agentResult.data, clearMessageCountTimer));
        }
        else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
}

export const getUserList = () => dispatch => {
    defaultAgent.get('api/chat/contact/list?__version=2').then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(userList(agentResult.data));
        }
        else if (agentResult.message) {
            // dispatch(toastError(agentResult.message));
            dispatch(userList());
        }
    }).catch(ex => {
        //dispatch(toastError(ex.message));
        dispatch(userList());
    });
}

export const getContactList = farmId => (dispatch, getState) => {
    const { chat } = getState();

    const dispatchContacts = (result, egList) => {
        const data = Array.isArray(result) ? { contacts: result, users: [] } : result;
        const idWiseEG = {};

        egList.forEach(e => idWiseEG[e.equipment_group_uuid] = e);
        const contacts = data.contacts.map(e => ((e.contact_role === "eg" && idWiseEG[e.id]) ? { ...e, avatar: idWiseEG[e.id].img.ic } : e));
        const users = data.users.map(e => ((e.user_type === "eg" && idWiseEG[e.contact_id.replace("eg_", "")]) ?
            { ...e, avatar: idWiseEG[e.contact_id.replace("eg_", "")].img.ic } : e));
        dispatch(chatContactList(contacts, users));
    };

    defaultAgent.get('/api/chat/fm/contact/list', { farm_uuid: farmId, __version: 1 }).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            if (chat.farmId === farmId && chat.egList && chat.egList.length > 0)
                dispatchContacts(agentResult.data, chat.egList);
            else getEGList(farmId, egList => {
                egList = egList ? egList : [];
                dispatch(updateChatEGList(farmId, egList));
                dispatchContacts(agentResult.data, egList);
            });
        }
        else if (agentResult.message) {
            // dispatch(toastError(agentResult.message));
            dispatch(chatContactList());
        }
    }).catch(ex => {
        //dispatch(toastError(ex.message));
        dispatch(chatContactList());
    });
}

export const handleFavorite = (params) => (dispatch) => {
    const reqParams = {
        contact_id: params.id,
        favorite: params.isFavorite
    }

    defaultAgent.put('/api/chat/contact/favorite', reqParams).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.code !== ADDED_FAVORITE.code && agentResult.message)
            dispatch(toastError(agentResult.message));
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
}

const getEGList = (farmId, cb) => {
    if (!cb) return;

    const params = {
        farm_uuid: farmId, img: 1, device: 0, crew: 0, operator: 0,
        vehicle_spec: 0, implement_spec: 0, vehicle: 0, implement: 0
    }

    defaultAgent.get('/api/equipment/group/v1/list', params)
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.data) cb(agentResult.data);
        }).catch(() => { cb(null); });
}

export const uploadFile = (to, messageId, attachments) => {
    return dispatch => {
        attachments.forEach(item => {
            if (item.storage === FILE_STORAGE_GOOGLE) {
                const params = {
                    method: 'POST',
                    headers: { 'content-type': item.file.type, 'Content-Range': 'bytes 0-500/500' },
                    data: item.file,
                    onUploadProgress: (progressEvent) => {
                        const { loaded, total } = progressEvent;
                        const uploadPercent = Math.round((loaded * 100) / total);
                        dispatch(fileUploadInProgress(to, messageId, item.id, uploadPercent, total));
                    }
                };

                const fileName = `${item.id}_${item.name}`;
                const promise = axios(`${config.storage.FILE_UPLOAD_URL}${fileName}`, params);
                promise.then(res => {
                    if (res.status === 200) {
                        const url = `${config.storage.FILE_RETRIEVE_URL}${fileName}`;
                        if (item.file.type.indexOf("audio") >= 0 || item.file.type.indexOf("video") >= 0)
                            getDuration(url, duration => dispatch(fileUploadedOnSuccess(to, messageId, item.id, url, duration)));
                        else
                            dispatch(fileUploadedOnSuccess(to, messageId, item.id, url));
                    }
                    else dispatch(fileUploadOnFailure(to, messageId, item.id));
                }).catch(ex => {
                    dispatch(fileUploadOnFailure(to, messageId, item.id));
                    dispatch(toastError(ex.message));
                });
            }
        });
    };
}

export const getDuration = (url, cb) => {
    const element = document.createElement("audio");
    element.id = "audio";
    element.src = url;
    element.onloadeddata = (event) => {
        const seconds = Math.round(event.target.duration);
        const t = {
            h: Math.floor(seconds / 3600),
            m: Math.floor(seconds % 3600 / 60),
            s: Math.floor(seconds % 3600 % 60)
        };

        const time = [];
        if (t.h > 0) {
            time.push(t.h);
            if ((t.m + t.s) === 0) time.push(0);
        }

        if (t.m > 0) {
            if (t.h === 0) time.push(0);
            time.push(t.m);
        }

        if (t.s > 0) {
            if (t.m === 0) time.push(0);
            time.push(t.s);
        };

        if (cb) cb(time.join(":"));
    }
}